import classNames from 'classnames';
import EcoImg from 'eco-design/base/eco-img';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { queryCategoryItemsList } from '../../common/blog-api/queryCategoryItems';
import BlogTimer from '../../common/blog-timer';

// 默认用户头像
const defaultUserIcon = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';
export default function Content({ id, data = {} }: any) {
    const { blogId, theme, textAlign, cardFontColor, cardFontSize, title, items = [] } = data;
    const prefixCls1 = 'editor-blog-recommend';
    const prefixCls2 = 'editor-blog-recommend-card';
    const { locale = 'us' } = useRouter();
    const items2 = items || [];
    const [itemA, setItemA] = useState<any>(items2[0] || {});
    const thePageA = JSON.parse(itemA.thePage || '{}');

    // 切换数据
    const getItemsForNone = async (categoryId: string) => {
        const dataA = await queryCategoryItemsList(locale, {
            ids: [categoryId],
        });
        const item1 = dataA[0] || {};
        setItemA(item1);
    };
    useEffect(() => {
        if (!items2.length) {
            getItemsForNone(blogId);
        }
    }, [blogId]);

    const classes = classNames(prefixCls1, {
        [`${prefixCls1}-theme-${theme}`]: theme,
        [`${prefixCls1}-textAlign-${textAlign}`]: textAlign,
    });
    const compStyle = {
        '--blog-recommend-item-label': cardFontColor,
        '--blog-recommend-item-title': cardFontColor,
        '--blog-recommend-item-desc': cardFontColor,
        '--blog-recommend-item-logo': cardFontColor,
        '--blog-recommend-cardFontSize': `${cardFontSize}px`,
    };
    return (
        <GloLayout className={classes} id={id} style={compStyle}>
            <div className="editor-blog-recommend-in eco-content">
                <div className="editor-blog-recommend-title">{title}</div>
                <div className="editor-blog-recommend-card">
                    <EcoLink href={itemA.seoUrl} className={`${prefixCls2}-img`}>
                        <EcoImgVideo isVideo={itemA.isVideo} pc={thePageA.blogImgPc} h5={thePageA.blogImgH5} />
                    </EcoLink>
                    <div className={`${prefixCls2}-msg`}>
                        <EcoLink href={itemA.categoryHref} className={`${prefixCls2}-label`}>
                            {itemA.label}
                        </EcoLink>
                        <EcoLink href={itemA.seoUrl} className={`${prefixCls2}-title`}>
                            {thePageA.blogTitle}
                        </EcoLink>
                        <div className={`${prefixCls2}-footer`}>
                            <div className={`${prefixCls2}-footer-icon`}>
                                <EcoImg pc={itemA.userIcon || defaultUserIcon} />
                            </div>
                            <div className={`${prefixCls2}-footer-logo`}>{itemA.userName || 'EcoFlow'}</div>
                            <div className={`${prefixCls2}-footer-time`}>- {BlogTimer(itemA.newFirstReleaseTime || itemA.firstReleaseTime, locale)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
